import { JSX } from 'react';
import { NonIndexRouteObject, RouteObject } from 'react-router';

import { LoaderPage } from '@component/loader/loader.page';

export const pageLazyLoader = <T extends { default: () => JSX.Element }>(page: Promise<T>): Promise<RouteObject> =>
  page.then(
    ({ default: Component }) =>
      ({
        Component,
        loader: LoaderPage,
      }) as NonIndexRouteObject,
  );
